import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale());

export const schema = yup.object({
  claId: yup
    .number()
    .nullable()
    .default(null)
    .transform((a) => (a ? a : null)),
  hourlyWageValue: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  hourlyWageValue20: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  hourlyWageValue19: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  hourlyWageValue18: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  hourlyWageValue17: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  hourlyWageValue16: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  hourlyWageValue15: yup
    .number()
    .min(0)
    .required(t('dutyCalculationValue.sleepDuty.errors.required')),
  valid: yup.object({
    from: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .nullable()
      .default(null),
    to: yup
      .date()
      .nullable()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .default(null)
      .min(yup.ref<Date>('from'), t('max_buh.errors.validFromRequired'))
  })
});
